import React from "react";

const Unauthorized = () => {
  return (
    <div className="flex justify-center items-center h-screen ">
      <div className="max-w-md p-6 bg-white shadow-md rounded-md">
        <h2 className="text-3xl font-semibold text-center text-gray-800 mb-4">
          Permission denied
        </h2>
        <p className="text-lg text-center text-gray-600">
          You are not authorized to access this page.
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;
